import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Coins, X } from 'lucide-react';
import { selectOutOfCredits, dismissOutOfCredits } from '../features/billing/billingSlice';
import { track } from '../analytics/analytics';
import './OutOfCreditsModal.css';

// Shown when a scan is rejected for insufficient credits (HTTP 402). Driven by
// billing.outOfCredits, which the scan flow sets on an InsufficientCreditsError.
function OutOfCreditsModal() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const info = useSelector(selectOutOfCredits);

  if (!info) return null;

  const { creditsRequired, creditsBalance, bandLabel } = info;

  const close = () => dispatch(dismissOutOfCredits());
  const topUp = () => {
    track('add_credits_clicked', { source: 'out_of_credits_modal' });
    dispatch(dismissOutOfCredits());
    navigate('/pricing');
  };

  return (
    <div className="ooc-overlay" onClick={close} role="presentation">
      <div
        className="ooc-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="ooc-title"
      >
        <button className="ooc-close" onClick={close} aria-label="Close">
          <X size={18} />
        </button>

        <div className="ooc-icon">
          <Coins size={28} aria-hidden="true" />
        </div>

        <h2 id="ooc-title" className="ooc-title">Not enough credits</h2>
        <p className="ooc-text">
          This scan{bandLabel && bandLabel !== 'Unknown' ? ` (${bandLabel})` : ''} costs{' '}
          <strong>{creditsRequired ?? '—'}</strong> credits, but you have{' '}
          <strong>{creditsBalance ?? 0}</strong>. Add credits to keep scanning.
        </p>

        <div className="ooc-actions">
          <button className="ooc-btn-secondary" onClick={close}>Not now</button>
          <button className="ooc-btn-primary" onClick={topUp}>Add credits</button>
        </div>
      </div>
    </div>
  );
}

export default OutOfCreditsModal;
